import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for C5N6 (S/C Closure Reversal)
// ============================================================

export interface ReversalItem {
  fc110_01: string;    // S/C No
  fc110_10: string;    // Dept code
  fc110_12: string;    // Customer name (F104 lookup)
  fc110_99: number;    // Gross profit (BR-C01)
  fc110_100: number;   // Gross profit rate % (BR-C02)
}

export interface QueryResponse {
  items: ReversalItem[];
  total: number;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c5n6Api = {
  /** Query S/C items eligible for closure reversal (FC110_53="P" AND FC110_71!="P") */
  async query(params: {
    sc_start?: string;
    sc_end?: string;
  }): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c5n6/query', params);
    return res.data;
  },

  /** Execute batch closure reversal for selected S/C items */
  async execute(scNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/c5n6/execute', {
      sc_nos: scNos,
    });
    return res.data;
  },
};
